import type { LoaderFunctionArgs, RouteObject } from 'react-router-dom';
import { replace } from 'react-router-dom';

import BootSplash from '@/shared/components/BootSplash';
import ROUTES from '@/shared/constants/routes';
import { qrPath } from './constants/routes';
import { PublicQrLayout } from './components/PublicQrLayout';

const withQuery = (path: string, request: Request) => `${path}${new URL(request.url).search}`;

/**
 * La página pública del QR, NINGUNA ruta bajo `Protected`: quien la abre es el
 * cliente del negocio, no un usuario de heru, y no tiene ni tiene por qué tener
 * cuenta.
 */
export const publicQrRoutes: RouteObject[] = [
  {
    // El provider cuelga de una ruta sin path para que la página y el estado de
    // la solicitud compartan LA MISMA resolución del motor. Si cada una leyera
    // la bandera por su cuenta, el cliente podría crear su solicitud en un
    // motor y consultarla en el otro.
    id: 'qr-public-engine',
    element: <PublicQrLayout />,
    hydrateFallbackElement: <BootSplash />,
    children: [
      {
        id: 'qr-public-page',
        path: ROUTES.QR_PUBLIC,
        lazy: async () => ({
          Component: (await import('./views/QrPosterPage')).QrPosterPage,
        }),
      },
      {
        id: 'qr-public-request',
        path: ROUTES.QR_PUBLIC_REQUEST,
        lazy: async () => ({
          Component: (await import('./views/QrPublicPage')).QrPublicPage,
        }),
      },
    ],
  },
  // `/facturacion-qr/*` ya no pinta nada: manda a la liga de siempre con el query intacto.
  {
    id: 'qr-public-retired',
    path: ROUTES.QR_PUBLIC_RETIRED,
    loader: ({ params, request }: LoaderFunctionArgs) =>
      replace(withQuery(qrPath.page(params.slug ?? ''), request)),
  },
  {
    id: 'qr-public-retired-request',
    path: ROUTES.QR_PUBLIC_RETIRED_REQUEST,
    loader: ({ params, request }: LoaderFunctionArgs) =>
      replace(withQuery(qrPath.request(params.publicId ?? ''), request)),
  },
  {
    id: 'qr-public-retired-step',
    path: ROUTES.QR_PUBLIC_RETIRED_STEP,
    loader: ({ params, request }: LoaderFunctionArgs) =>
      replace(withQuery(qrPath.page(params.slug ?? ''), request)),
  },
];
